import { actions, selectors } from '../../state';
import './get-started.global.css';

export default class GetStartedController {
  constructor($scope, updStore) {
    'ngInject';
    const { dispatch, connect } = updStore;

    Object.assign(this, {
      $scope,
      dispatch,
    });

    const disconnect = connect(mapStateToThis)(this);
    $scope.$on('$destroy', disconnect);
  }

  submit() {
    const { dispatch } = this;

    let success = () => {
      dispatch(actions.router.stateGo(this.next));
      dispatch(actions.analytics.track(this.successEvent));
    };

    this.$scope.$broadcast('submit', success);
  }
}

function mapStateToThis(state) {
  const { currentDataProp, currentAnalyticsProp } = selectors.router;

  return {
    header: currentDataProp('header', state),
    subHeader: currentDataProp('subHeader', state),
    stepIndicatorIndex: currentDataProp('stepIndicatorIndex', state),
    next: currentDataProp('next', state),
    successEvent: currentAnalyticsProp('success', state),
  };
}
